module.exports = __webpack_public_path__ + "img/remitly.99688ab5.png";